let checkForPages = true

function lastPageChecker(ctx) {
    // WORKAROUND: This is a workaround to check if the last page is reached.
    console.log({ checkForPages, ...ctx });
    const { gridItems } = ctx;
    if (gridItems[0].classList.contains('js-grid__full-row')) {
        checkForPages = false;
    }
}

function resetScrollList() {
    loadListener()
    function loadListener() {
        document.querySelectorAll('[data-sidebar-filter-form] input').forEach((input) => {
            input.addEventListener('change', () => {
                checkForPages = true;
                document.querySelector('#infinity-scroll').dataset.currentPage = 1;
                // Apply listers after filters are reloaded on the page
                setTimeout(() => {
                    loadListener();
                }, 6000)
            });
        })
    }
}

async function fetchURL(url) {
    try {
        const response = await fetch(url);
        return response.text();
    } catch (error) {
        console.error(error);
    }
}

async function getNextPageProductGrid({ grid_selector, nextPageURL }) {
    try {
        const html = await fetchURL(nextPageURL);
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        const productGrid = doc.querySelector(grid_selector);
        return productGrid;
    } catch (error) {
        console.error(error);
    }
}

async function getNextPageItems({ grid_item_selector, grid_selector, nextPageURL }) {
    try {
        const productGrid = await getNextPageProductGrid({ grid_selector, nextPageURL });
        const gridItems = productGrid.querySelectorAll(grid_item_selector);
        return gridItems;
    } catch (error) {
        console.error(error);
    }
}

async function loadNextPageItems({ grid_item_selector, grid_selector }) {
    try {
        const dataTotalPages = document.querySelector('#infinity-scroll').dataset.totalPages;
        const dataCurrentPage = document.querySelector('#infinity-scroll').dataset.currentPage;
        if (!dataTotalPages || !dataCurrentPage) {
            return;
        }
        const totalPages = Number(dataTotalPages);
        const currentPage = Number(dataCurrentPage);
        let nextPageURL;
        if (window.location.search) {
            const urlParams = new URLSearchParams(window.location.search);
            urlParams.set('page', parseInt(currentPage) + 1);
            nextPageURL = window.location.origin + window.location.pathname + '?' + urlParams.toString();
        } else {
            nextPageURL = window.location.href + '?page=' + (parseInt(currentPage) + 1);
        }
        document.querySelector('#infinity-scroll').dataset.currentPage = parseInt(currentPage) + 1;
        const gridItems = await getNextPageItems({ grid_item_selector, grid_selector, nextPageURL });

        lastPageChecker({
            totalPages,
            currentPage,
            gridItems,
        })
        if (!checkForPages) return
        const grid = document.querySelector(grid_selector);
        grid.append(...gridItems);
    } catch (error) {
        console.error(error);
    }
}

function monitorScrollDistance(selector, callback) {
    let isRunning = false;
    const element = document.querySelector(selector);
    const spinnerWrapper = document.createElement('div');
    const spinner = document.createElement('div');
    spinner.className = 'spinner';
    spinnerWrapper.className = 'spinner-wrapper';
    spinnerWrapper.appendChild(spinner);
    element.parentNode.append(spinnerWrapper);

    window.addEventListener('scroll', async () => {
        const rect = element.getBoundingClientRect();
        const distanceFromBottom = rect.bottom - window.innerHeight;
        if (distanceFromBottom >= 800 || isRunning || !checkForPages) return
        isRunning = true;
        spinner.style.display = 'block';
        await callback();
        isRunning = false;
        spinner.style.display = 'none';
    });
}
async function loadNextGridItems() {
    await loadNextPageItems({
        grid_item_selector: '.js-grid > div',
        grid_selector: '.js-grid'
    });
}

monitorScrollDistance('.js-grid', loadNextGridItems);

document.addEventListener('DOMContentLoaded', () => {
    resetScrollList();
})